import React from 'react'
import { Space, Form, Input, Col, Row, Button, InputNumber, Modal, Checkbox } from 'antd';
import { useTranslation } from "react-i18next";
import styles from '../../style.module.css'
import { useSelector } from 'react-redux'
import { addDgrType } from '../../../../../constant/enumerations';

const placeHolders = {
    COD_UID: 'eg: 1234',
    SHIPPING_NAME: 'eg: Printing Ink',
    CLASS_DIVISION: 'eg: 3',
    PACKING_GROUP: 'eg: I',
    QUANTITY_AND_TYPE: 'eg: 1 Fibreboard box x 5.0L',
    PACKING_INST: 'eg: 353',
    AUTHORIZATION: 'eg: My Full Name',
}
export const AddDangerousGoodsModal = ({ editingKey, modalVisible, handleAddOrSave, setModalVisible, form, typeAdd, isCheckMamCheckbox, setIsCheckMamCheckbox }) => {
    const { t } = useTranslation("common");
    const { user_name, fullName } = useSelector((state) => state.userAwb.currentUser);
    const dgrTypeStatusOK = useSelector(state => state.dgrGoods.dgrTypeStatusOK);
    const esidExport = useSelector((state) => state.esidExport.esidExpSelected);

    // const hasAdminAcpt = useHasRoles([RoleClaim.EsidACPT]); 
    // nếu = true thì có quyền admin

    const hideModal = () => {
        setModalVisible(false);
    }
    const handleSubmit = (formValue) => {
        // console.log(formValue);
        let dgrTypes = [];

        //dgr
        if (formValue?.shcDgd) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'DGD');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        if (formValue?.shcCao) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'CAO');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        if (formValue?.shcMam) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'MAM');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: formValue?.pc,
                namDgrSfx: "PC",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        if (formValue?.shcUN3373) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'UN3373');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        // if(formValue?.note) {
        //     const dgrType = {
        //         codDgr: "",
        //         dgrNam: "",
        //         note: formValue.note,
        //         namDgrExt: "",
        //         namDgrSfx: ""
        //     }
        //     dgrTypes.push(dgrType);
        // }

        //ice
        if (formValue?.shcDric) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'DRIC');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        if (formValue?.shcUN1845) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'UN1845');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        //pin
        if (formValue?.shcUN3481) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'UN3481');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        if (formValue?.shcUN3091) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'UN3091');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        if (formValue?.shcPI966) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'PI966');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        if (formValue?.shcPI967) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'PI967');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        if (formValue?.shcPI969) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'PI969');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        if (formValue?.shcPI970) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'PI970');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        if (formValue?.shcEli) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'ELI');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        if (formValue?.shcElm) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'ELM');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }

        // console.log(formValue, editingKey, dgrTypes);

        editingKey !== '' ? handleAddOrSave(formValue, dgrTypes, editingKey) : handleAddOrSave(formValue, dgrTypes);
        setModalVisible(false);
        form.resetFields();
    }
    const handleAddAndCreateAnother = async () => {
        const formValue = await form.validateFields();
        // console.log(formValue);
        let dgrTypes = [];

        //dgr
        if (formValue?.shcDgd) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'DGD');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        if (formValue?.shcCao) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'CAO');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        if (formValue?.shcMam) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'MAM');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: formValue?.pc,
                namDgrSfx: "PC",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        if (formValue?.shcUN3373) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'UN3373');
            dgrTypes.push({
                esidId: esidExport.id,
                ...dgrType,
                namDgrExt: "",
                namDgrSfx: "",
                note: "",
                sorter: dgrType.codSrt,
            });
        }
        // if(formValue?.note) {
        //     const dgrType = {
        //         codDgr: "",
        //         dgrNam: "",
        //         note: formValue.note,
        //         namDgrExt: "",
        //         namDgrSfx: ""
        //     }
        //     dgrTypes.push(dgrType);
        // }

        //ice
        if (formValue?.shcDric) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'DRIC');
            dgrTypes.push(dgrType);
        }
        if (formValue?.shcUN1845) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'UN1845');
            dgrTypes.push(dgrType);
        }
        //pin
        if (formValue?.shcUN3481) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'UN3481');
            dgrTypes.push(dgrType);
        }
        if (formValue?.shcUN3091) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'UN3091');
            dgrTypes.push(dgrType);
        }
        if (formValue?.shcPI966) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'PI966');
            dgrTypes.push(dgrType);
        }
        if (formValue?.shcPI967) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'PI967');
            dgrTypes.push(dgrType);
        }
        if (formValue?.shcPI969) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'PI969');
            dgrTypes.push(dgrType);
        }
        if (formValue?.shcPI970) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'PI970');
            dgrTypes.push(dgrType);
        }
        if (formValue?.shcEli) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'ELI');
            dgrTypes.push(dgrType);
        }
        if (formValue?.shcElm) {
            const dgrType = dgrTypeStatusOK.find(dgrType => dgrType.codDgr === 'ELM');
            dgrTypes.push(dgrType);
        }

        // console.log(formValue, editingKey, dgrTypes);

        editingKey !== '' ? handleAddOrSave(formValue, editingKey, dgrTypes) : handleAddOrSave(formValue, dgrTypes);
        form.resetFields();
        const firstField = document.getElementById('unSelect');
        firstField !== null && firstField.focus();
    }

    const onChangeMamCheckbox = (e) =>{
        const val = e.target.checked
        if(!val){
          form.setFieldsValue({
            pc: ''
          })
        }
        setIsCheckMamCheckbox(val);
    }

    return (
        <Modal
            visible={modalVisible}
            onCancel={hideModal}
            footer={null}
            centered
            className={styles.AddModal}
        >
            {typeAdd === addDgrType.DGR && (
                <Form
                    labelAlign='left'
                    labelCol={{ span: 24 }}
                    onFinish={handleSubmit}
                    form={form}
                    initialValues={{
                        dgrAuth: fullName || user_name
                    }}
                    autoComplete="off"
                >
                    {/* <Form.Item label={t('dangerousGood.formInfo.UN')} required>
                        <Input.Group compact>
                            <Form.Item
                                name="dgrRegSeq"
                                noStyle
                                rules={[
                                    {
                                        required: true,
                                        message: t('dangerousGood.errorInfo.required'),
                                    },
                                ]}
                            >
                                <UNSelect form={form} isSelectOpen={isUNSelectOpen} setIsSelectOpen={setIsUNSelectOpen} />
                            </Form.Item>
                            {
                                !isUNSelectOpen &&
                                <Form.Item
                                    name="codPsn"
                                    noStyle
                                >
                                    <Input placeholder={placeHolders.SHIPPING_NAME} style={{ width: '70%' }} />
                                </Form.Item>
                            }
                        </Input.Group>
                    </Form.Item> */}
                    <Row>
                        {/* <Col lg={6} md={8} sm={24} xs={24} style={{padding: 0}}> */}
                        <Col span={24}>
                            <Form.Item
                                name='codUid'
                                label={t('dangerousGood.formInfo.UN')}
                                rules={[
                                    {
                                        required: true,
                                        message: t('dangerousGood.errorInfo.required'),
                                    },
                                ]}
                            >
                                <Input placeholder={placeHolders.COD_UID} maxLength={300} />
                            </Form.Item>
                        </Col>
                        {/* <Col lg={18} md={16} sm={24} xs={24} style={{padding: '0 0 0 5px'}}>
                            <Form.Item
                                name="codPsn"
                                label={t('dangerousGood.formInfo.probShpName')}
                                rules={[
                                    {
                                        required: true,
                                        message: t('dangerousGood.errorInfo.required'),
                                    },
                                ]}
                            >
                                <Input placeholder={placeHolders.SHIPPING_NAME} />
                            </Form.Item>
                        </Col> */}
                    </Row>
                    <Row>
                        <Col lg={12} md={24} sm={24} xs={24} style={{padding: 0}}>
                            <Form.Item
                                name="codShc"
                                label="SHC"
                            >
                                <Input
                                    style={{width: '100%', height: '100%'}} 
                                    size={'medium'} 
                                />
                            </Form.Item>
                        </Col>
                        <Col lg={12} md={24} sm={24} xs={24} style={{padding: '0 0 0 5px'}}>
                            <Form.Item
                                name="codErg"
                                label="ERG Code"
                            >
                                <Input
                                    style={{width: '100%', height: '100%'}} 
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12} md={24} sm={24} xs={24} style={{padding: 0}}>
                            <Form.Item
                                name="qtyPcs"
                                label="Số kiện"
                                rules={[
                                    { 
                                    type:'number',
                                    message: `${t('dangerousGood.errorInfo.onlyNum')}`
                                    }
                                ]}
                            >
                                <InputNumber 
                                    style={{width: '100%', height: '100%'}} 
                                    size={'medium'} 
                                    min={0} 
                                    placeholder={placeHolders.PIECES}
                                />
                            </Form.Item>
                        </Col>
                        <Col lg={12} md={24} sm={24} xs={24} style={{padding: '0 0 0 5px'}}>
                            <Form.Item
                                name="qtyWgt"
                                label={t('dangerousGood.formInfo.qtyWgt')}
                                rules={[
                                    { 
                                    type:'number',
                                    message: `${t('dangerousGood.errorInfo.onlyNum')}`
                                    }
                                ]}
                            >
                                <InputNumber
                                    type='number' 
                                    style={{width: '100%', height: '100%'}} 
                                    size={'medium'} 
                                    min={1} 
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                        <Form.Item
                            name="desRmk"
                            label={t('dangerousGood.formInfo.note')}
                            style={{ marginBottom: 0}}
                        >
                            <Input.TextArea autoSize={{ minRows: 3 }}/>
                        </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{marginTop: '10px', marginBottom: '5px'}}>
                            <div style={{ fontWeight: 'bold' }}>{t("dangerousGood.formInfo.dgrType")}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ marginBottom: '10px', marginTop: '10px' }}>
                            <Form.Item
                                name="shcDgd"
                                noStyle
                                valuePropName="checked"
                            >
                                <Checkbox>
                                    {t("dangerousGood.formInfo.shcDgd")}
                                </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={24} style={{ marginBottom: '10px' }}>
                            <Form.Item
                                name="shcCao"
                                noStyle
                                valuePropName="checked"
                            >
                                <Checkbox>
                                    {t("dangerousGood.formInfo.shcCao")}
                                </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                            <Form.Item
                                name="shcMam"
                                noStyle
                                valuePropName="checked"
                            >
                                <Checkbox onChange={onChangeMamCheckbox}>
                                    {t("dangerousGood.formInfo.shcMam")}
                                </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                            <Form.Item
                                name="pc"
                                noStyle
                            >
                                <Input suffix="PC" disabled={!isCheckMamCheckbox}/>
                            </Form.Item>
                        </Col>
                        <Col span={24} style={{ marginBottom: '10px' }}>
                            <Form.Item
                                name="shcUN3373"
                                noStyle
                                valuePropName="checked"
                            >
                                <Checkbox>
                                    {t("dangerousGood.formInfo.shcUN3373")}
                                </Checkbox>
                            </Form.Item>
                        </Col>
                        {/* <Col span={24}>
                            <Form.Item
                                name="note"
                                label="Note"
                                labelCol={8}
                                wrapperCol={16}
                            >
                                <Input />
                            </Form.Item>
                        </Col> */}
                    </Row>
                    <Form.Item style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                        <Space style={{ justifyContent: 'center', width: '100%' }} >
                            <Button type='primary' htmlType='submit' className={styles.submitBtn}>
                                {editingKey !== '' ? t("admin.esid.saveBtn") : t('admin.esid.createBtn')}
                            </Button>
                            <Button type='primary' onClick={handleAddAndCreateAnother} className={styles.submitBtn}>
                                {t("admin.esid.saveAndCreateBtn")}
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            )}
            {typeAdd === addDgrType.ICE && (
                <Form
                    labelAlign='left'
                    labelCol={{ span: 24 }}
                    onFinish={handleSubmit}
                    form={form}
                    initialValues={{
                        shcDric: false,
                        shcUN1845: false
                    }}
                    autoComplete="off"
                >
                    <Row>
                        <Col lg={12} md={24} sm={24} xs={24} style={{padding: 0}}>
                            <Form.Item
                                name="codShc"
                                label="SHC"
                            >
                                <Input
                                    style={{width: '100%', height: '100%'}} 
                                    size={'medium'} 
                                />
                            </Form.Item>
                        </Col>
                        <Col lg={12} md={24} sm={24} xs={24} style={{padding: '0 0 0 5px'}}>
                            <Form.Item
                                name="codErg"
                                label="ERG Code"
                            >
                                <Input
                                    style={{width: '100%', height: '100%'}} 
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12} md={24} sm={24} xs={24} style={{padding: 0}}>
                            <Form.Item
                                name="qtyPcs"
                                label="Số kiện"
                                rules={[
                                    {
                                    required: true,
                                    message: `${t('dangerousGood.errorInfo.required')}`,
                                    },
                                    { 
                                    type:'number',
                                    message: `${t('dangerousGood.errorInfo.onlyNum')}`
                                    }
                                ]}
                            >
                                <InputNumber 
                                    style={{width: '100%', height: '100%'}} 
                                    size={'medium'} 
                                    min={1} 
                                    placeholder={placeHolders.PIECES}
                                />
                            </Form.Item>
                        </Col>
                        <Col lg={12} md={24} sm={24} xs={24} style={{padding: '0 0 0 5px'}}>
                            <Form.Item
                                name="qtyWgt"
                                label={t('dangerousGood.formInfo.qtyWgt')}
                                rules={[
                                    { 
                                    type:'number',
                                    message: `${t('dangerousGood.errorInfo.onlyNum')}`
                                    }
                                ]}
                            >
                                <InputNumber
                                    type='number' 
                                    style={{width: '100%', height: '100%'}} 
                                    size={'medium'} 
                                    min={1} 
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                        <Form.Item
                            name="desRmk"
                            label={t('dangerousGood.formInfo.note')}
                            style={{ marginBottom: 0}}
                        >
                            <Input.TextArea autoSize={{ minRows: 3 }}/>
                        </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{marginTop: '10px', marginBottom: '5px'}}>
                            <div style={{ fontWeight: 'bold' }}>{t("dangerousGood.formInfo.dgrType")}</div>
                        </Col>
                    </Row>
                    <Row>
                        {/* <Col span={24} style={{ marginBottom: '10px' }}>
                            <Form.Item
                                name="shcDric"
                                noStyle
                                valuePropName="checked"
                            >
                                <Checkbox>
                                    {t("dangerousGood.formInfo.shcDric")}
                                </Checkbox>
                            </Form.Item>
                        </Col> */}
                        <Col span={24} style={{ marginBottom: '10px' }}>
                            <Form.Item
                                name="shcUN1845"
                                noStyle
                                valuePropName="checked"
                            >
                                <Checkbox>
                                    {t("dangerousGood.formInfo.shcUN1845")}
                                </Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                        <Space style={{ justifyContent: 'center', width: '100%' }} >
                            <Button type='primary' htmlType='submit' className={styles.submitBtn}>
                                {editingKey !== '' ? t("admin.esid.saveBtn") : t('admin.esid.createBtn')}
                            </Button>
                            <Button type='primary' onClick={handleAddAndCreateAnother} className={styles.submitBtn}>
                                {t("admin.esid.saveAndCreateBtn")}
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            )}
            {typeAdd === addDgrType.PIN && (
                <Form
                    labelAlign='left'
                    labelCol={{ span: 24 }}
                    onFinish={handleSubmit}
                    form={form}
                    initialValues={{
                        shcUN3481: false,
                        shcUN3091: false,
                        shcPI966: false,
                        shcPI967: false,
                        shcPI969: false,
                        shcPI970: false,
                        shcEli: false,
                        shcElm: false
                    }}
                    autoComplete="off"
                >
                    <Row>
                        <Col lg={12} md={24} sm={24} xs={24} style={{padding: 0}}>
                            <Form.Item
                                name="codShc"
                                label="SHC"
                            >
                                <Input
                                    style={{width: '100%', height: '100%'}} 
                                    size={'medium'} 
                                />
                            </Form.Item>
                        </Col>
                        <Col lg={12} md={24} sm={24} xs={24} style={{padding: '0 0 0 5px'}}>
                            <Form.Item
                                name="codErg"
                                label="ERG Code"
                            >
                                <Input
                                    style={{width: '100%', height: '100%'}} 
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12} md={24} sm={24} xs={24} style={{padding: 0}}>
                            <Form.Item
                                name="qtyPcs"
                                label="Số kiện"
                                rules={[
                                    {
                                    required: true,
                                    message: `${t('dangerousGood.errorInfo.required')}`,
                                    },
                                    { 
                                    type:'number',
                                    message: `${t('dangerousGood.errorInfo.onlyNum')}`
                                    }
                                ]}
                            >
                                <InputNumber 
                                    style={{width: '100%', height: '100%'}} 
                                    size={'medium'} 
                                    min={1} 
                                    placeholder={placeHolders.PIECES}
                                />
                            </Form.Item>
                        </Col>
                        <Col lg={12} md={24} sm={24} xs={24} style={{padding: '0 0 0 5px'}}>
                            <Form.Item
                                name="qtyWgt"
                                label={t('dangerousGood.formInfo.qtyWgt')}
                                rules={[
                                    { 
                                    type:'number',
                                    message: `${t('dangerousGood.errorInfo.onlyNum')}`
                                    }
                                ]}
                            >
                                <InputNumber 
                                    type='number'
                                    style={{width: '100%', height: '100%'}} 
                                    size={'medium'} 
                                    min={1}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                        <Form.Item
                            name="desRmk"
                            label={t('dangerousGood.formInfo.note')}
                            style={{ marginBottom: 0}}
                        >
                            <Input.TextArea autoSize={{ minRows: 3 }}/>
                        </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{marginTop: '10px', marginBottom: '5px'}}>
                            <div style={{ fontWeight: 'bold' }}>{t("dangerousGood.formInfo.dgrType")}</div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ marginBottom: '10px' }}>
                            <Form.Item
                                name="shcUN3481"
                                noStyle
                                valuePropName="checked"
                            >
                                <Checkbox>
                                    {t("dangerousGood.formInfo.shcUN3481")}
                                </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={24} style={{ marginBottom: '10px' }}>
                            <Form.Item
                                name="shcUN3091"
                                noStyle
                                valuePropName="checked"
                            >
                                <Checkbox>
                                    {t("dangerousGood.formInfo.shcUN3091")}
                                </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={24} style={{ marginBottom: '10px' }}>
                            <Form.Item
                                name="shcPI966"
                                noStyle
                                valuePropName="checked"
                            >
                                <Checkbox>
                                    {t("dangerousGood.formInfo.shcPI966")}
                                </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={24} style={{ marginBottom: '10px' }}>
                            <Form.Item
                                name="shcPI967"
                                noStyle
                                valuePropName="checked"
                            >
                                <Checkbox>
                                    {t("dangerousGood.formInfo.shcPI967")}
                                </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={24} style={{ marginBottom: '10px' }}>
                            <Form.Item
                                name="shcPI969"
                                noStyle
                                valuePropName="checked"
                            >
                                <Checkbox>
                                    {t("dangerousGood.formInfo.shcPI969")}
                                </Checkbox>
                            </Form.Item>
                        </Col>
                        <Col span={24} style={{ marginBottom: '10px' }}>
                            <Form.Item
                                name="shcPI970"
                                noStyle
                                valuePropName="checked"
                            >
                                <Checkbox>
                                    {t("dangerousGood.formInfo.shcPI970")}
                                </Checkbox>
                            </Form.Item>
                        </Col>
                        {/* <Col span={24} style={{ marginBottom: '10px' }}>
                            <Form.Item
                                name="shcEli"
                                noStyle
                                valuePropName="checked"
                            >
                                <Checkbox>
                                    {t("dangerousGood.formInfo.shcEli")}
                                </Checkbox>
                            </Form.Item>
                        </Col> */}
                        {/* <Col span={24} style={{ marginBottom: '10px' }}>
                            <Form.Item
                                name="shcElm"
                                noStyle
                                valuePropName="checked"
                            >
                                <Checkbox>
                                    {t("dangerousGood.formInfo.shcElm")}
                                </Checkbox>
                            </Form.Item>
                        </Col> */}
                    </Row>
                    <Form.Item style={{ display: 'flex', justifyContent: 'center', marginTop: 10 }}>
                        <Space style={{ justifyContent: 'center', width: '100%' }} >
                            <Button type='primary' htmlType='submit' className={styles.submitBtn}>
                                {editingKey !== '' ? t("admin.esid.saveBtn") : t('admin.esid.createBtn')}
                            </Button>
                            <Button type='primary' onClick={handleAddAndCreateAnother} className={styles.submitBtn}>
                                {t("admin.esid.saveAndCreateBtn")}
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            )}
        </Modal>
    )
}
